import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { QuizAttemptData } from 'quiz-types';

interface SubmissionData {
  submissionDate?: Date;
  grade?: number | null;
  s3_url?: string;
}

interface GRADER_STATE_TYPE {
  email: string | undefined;
  first_name: string | undefined;
  last_name: string | undefined;
  attempt: QuizAttemptData | undefined;
  submission: SubmissionData | undefined;
}

const INITIAL_STATE: GRADER_STATE_TYPE = {
  email: undefined,
  first_name: undefined,
  last_name: undefined,
  attempt: undefined,
  submission: undefined,
};

const graderSlice = createSlice({
  name: 'grader',
  initialState: INITIAL_STATE,
  reducers: {
    setAttemptUserEmail(state: GRADER_STATE_TYPE, action: PayloadAction<string | undefined>) {
      state.email = action.payload;
    },
    setAttemptUserFirstName(state: GRADER_STATE_TYPE, action: PayloadAction<string | undefined>) {
      state.first_name = action.payload;
    },
    setAttemptUserLastName(state: GRADER_STATE_TYPE, action: PayloadAction<string | undefined>) {
      state.last_name = action.payload;
    },
    setAttemptGradingData(
      state: GRADER_STATE_TYPE,
      action: PayloadAction<QuizAttemptData | undefined>,
    ) {
      state.attempt = action.payload;
    },
    setSubmissionGradingData(
      state: GRADER_STATE_TYPE,
      action: PayloadAction<SubmissionData | undefined>,
    ) {
      state.submission = action.payload;
    },
    resetGraderSlice(state: GRADER_STATE_TYPE) {
      state.email = INITIAL_STATE.email;
      state.first_name = INITIAL_STATE.first_name;
      state.last_name = INITIAL_STATE.last_name;
      state.attempt = INITIAL_STATE.attempt;
      state.submission = INITIAL_STATE.submission;
    },
  },
});

export const {
  setAttemptUserEmail,
  setAttemptUserFirstName,
  setAttemptUserLastName,
  setAttemptGradingData,
  setSubmissionGradingData,
  resetGraderSlice,
} = graderSlice.actions;
export default graderSlice.reducer;
